<template>
  <div>
    <div
      v-if="showSidebar"
      :class="$forms.overlay"
      @click="hideSidebar"
    />

    <v-navigation-drawer :width="640"
                         :value="showSidebar"
                         right fixed>
      <div :class="$style.detailsContainer">
        <vue-custom-scrollbar
          class="scroll-area"
          :settings="settings">
          <div :class="$style.detailsMain">
            <div :class="$style.detailsHeader">
              <h2 :class="$style.detailsTitle">
                {{ sidebarTitle }}
                <span v-if="!readOnly" :class="$style.deleteBtn"
                      @click="deleteItem">
                <app-svg-icon name="ic_delete"
                              :class="$style.iconDelete"/>
                </span>
                <span :class="$style.closeBtn"
                      @click="hideSidebar">
                <app-svg-icon name="ic_close"
                              :class="$style.iconClose"/>
              </span>
              </h2>
              <slot name="detailsHeader" />

              <app-button text="Edit"
                          button-style="accent"
                          :disabled="readOnly"
                          :class="$style.editBtn"
                          @click="editItem"/>

            </div>

            <div :class="$style.detailsContent">
              <slot name="detailsContent"/>
            </div>
            <div v-if="showFooter"
                 :class="$style.detailsFooter">
              <slot name="detailsFooter"/>
            </div>
          </div>

        </vue-custom-scrollbar>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import VueCustomScrollbar from 'vue-custom-scrollbar';

export default {
  props: {
    width: {
      type: Number,
      default: 600,
    },
    showSidebar: {
      type: Boolean,
      default: false,
    },
    sidebarTitle: {
      type: String,
      default: '',
    },
    formInvalid: {
      type: Boolean,
      default: true,
    },
    showFooter: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VueCustomScrollbar,
  },
  data() {
    return {
      settings: {
        wheelSpeed: 0.5,
      },
    };
  },
  methods: {
    hideSidebar(e) {
      this.$emit('hideSidebar', e);
    },
    editItem() {
      this.$emit('editItem');
    },
    deleteItem() {
      this.$emit('deleteItem');
    },
  },
};
</script>

<style src="@/styles/forms.scss" lang="scss" module="$forms"></style>
<style src="@/styles/modals.scss" lang="scss" module="$modals"></style>
<style lang="scss" module>
@import "@/styles/variables.scss";

.detailsContainer {
  height: 100%;
  display: flex;
  flex-direction: column;

  .detailsHeader {
    text-align: center;
    position: relative;
  }

  .detailsTitle {
    display: inline-block;
    padding-left: 28px;
    margin: 40px 40px 9px;
    text-align: center;
  }

  .detailsMain {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .detailsContent {
    flex-grow: 1;
    margin-top: 20px;
    margin-bottom: 40px;
  }

  .detailsFooter {
    box-shadow: 0 -1px 3px 0 $light-grey;
    padding: 15px 40px;
  }

  .deleteBtn {
    padding-left: 16px;
    cursor: pointer;

    .iconDelete {
      width: 12px;
      height: 16px;
    }
  }

  .closeBtn {
    position: absolute;
    top: 24px;
    right: 24px;
    width: 26px;
    height: 26px;
    cursor: pointer;

    .iconClose {
      width: 26px;
      height: 26px;
    }
  }

  .editBtn {
    padding: 8px 60px;
    display: block;
    margin: 0 auto;
  }
}
</style>

<style lang="scss">
@import "@/styles/variables.scss";

.v-navigation-drawer--clipped {
  &:not(.v-navigation-drawer--temporary) {
    &:not(.v-navigation-drawer--is-mobile) {
      z-index: 999;
    }
  }
}

.v-overlay--active {
  pointer-events: none;
}
</style>
